import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import styles from './Card.css';

interface IProps {
  children: React.ReactNode;
  link: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?(): void;
}

export const Card = ({ children, link, className, style, onClick }: IProps) => {
  const { className: rootClassName } = mergeStyles(styles['card'], className);

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={link} target="_blank" rel="noopener" className={rootClassName} style={style} onClick={onClick}>
      {children}
    </a>
  );
};
